import { render, staticRenderFns } from "./BonusTage.vue?vue&type=template&id=14a76fd8&"
import script from "./BonusTage.vue?vue&type=script&lang=js&"
export * from "./BonusTage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports